export default function Statistics() {
    return <div>Statistics</div>;
}
